import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../Styles/Order.css";
import locales from "../../../_constants/locales";

class Item extends Component {
    getItemPicture(sku) {
        return `https://static.koboscm.com/images/RakutenKobo/devices/${sku}.png`;
    }

    handleViewItem() {
        window.open(this.props.item.store_data.product_url, "_blank");
    }

    getFilterProtectionLineItemName(protectionLineItem) {
        let firstPart = protectionLineItem.name.slice(0, protectionLineItem.name.indexOf("-")).replace("Clyde", "");
        let secondPart = "";

        if (protectionLineItem.properties && protectionLineItem.properties.some(p => p.name === "Reference")) {
            let referenceItem = this.props.order.line_items.filter(
                li => li.requires_shipping === true && li.variant_id.toString() === protectionLineItem.properties.filter(p => p.name === "Reference")[0].value
            )[0];

            if (referenceItem) {
                secondPart = referenceItem.name;
            }
        }

        return `${firstPart}${secondPart != "" ? " - " + secondPart : ""}`;
    }

    getFilterProtectionLineItemYear(protectionLineItem) {
        let yearsCoverage = protectionLineItem.name.substring(protectionLineItem.name.indexOf("/") + 1);
        return yearsCoverage;
    }

    getFilteredLineItemName(lineItem) {
        if (lineItem.requires_shipping === false && !lineItem.sku.includes("EGIFTCARD")) {
            return `${this.getFilterProtectionLineItemName(lineItem)} - ${this.getFilterProtectionLineItemYear(lineItem)}`;
        } else {
            return `${lineItem.title}${lineItem.variant_title ? ` - ${lineItem.variant_title}` : ""}`;
        }
    }

    render() {
        return (
            <div className="flex layout horizontal order-item">
                <div className="flex order-item-image-box relative">
                    <img className="order-item-image" src={this.getItemPicture(this.props.item.sku)} alt="" />
                    <div className={`order-item-quantity${this.props.item.sku.includes("EGIFTCARD") ? " egiftcard" : ""}`}>{this.props.item.quantity}</div>
                </div>

                <div className="flex order-item-details">
                    <div className="order-item-details-text">
                        <p>{this.getFilteredLineItemName(this.props.item)}</p>
                        <p>{this.props.item.price_formatted}</p>
                    </div>
                    {this.props.item.store_data.product_url && (
                        <button className="view-item-button" onClick={this.handleViewItem.bind(this)}>
                            {locales[this.props.store[0]][this.props.language].ORDER_PAGE.ITEMS_SECTION.VIEW_ITEM}
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(Item);



// WEBPACK FOOTER //
// ./src/views/Order/components/_Item.jsx